module.exports = __webpack_public_path__ + "static/media/win_conference.5713bb14.png";